import { render, staticRenderFns } from "./LabourRateIndex.vue?vue&type=template&id=26d1e951"
import script from "./LabourRateIndex.vue?vue&type=script&lang=ts"
export * from "./LabourRateIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports